<template>
  <q-dialog ref="mapModalDialog" style="z-index: 10" maximized>
    <q-layout
      view="Lhh lpR fff"
      container
      class="bg-white modal-large consumerUnitAddressContainer"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="pin_drop" size="25px" class="q-pr-sm" />
            {{ $gettext("VIEW_MAP") }} ( {{ latitude }} - {{ longitude }} )
          </q-toolbar-title>
          <q-btn flat @click="hideMap">
            <q-icon name="cancel" size="2.5em" />
          </q-btn>
        </q-toolbar>
      </q-header>
      <q-page-container>
        <div id="pac-container">
          <input id="pac-input" type="text" placeholder="Buscar Endereco" />
        </div>
        <div id="map" class="map" style="height: 720px" />
        <div class="row full-width q-col-gutter-lg justify-center q-py-md">
            <div class="col-lg-2 col-md-3">
              <q-btn class="full-width" color="info" @click="save">
                <translate>SAVE</translate>
              </q-btn>
            </div>
          </div>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Loader } from '@googlemaps/js-api-loader'

const loader = new Loader({
  apiKey: 'AIzaSyB6ILg5YP8kp1jqePuD6RAAu6MZLUT7v0k',
  version: 'weekly',
  libraries: ['places']
})

@Component({
  components: {
    Loader
  },
  props: {
    latitude: Number,
    longitude: Number
  }
})
class MapModal extends Vue {
  map = null;
  marker = null;

  hideMap () {
    this.$refs.mapModalDialog.hide()
    this.$emit('close-modal')
  }

  async initMap () {
    const self = this
    let center = { lat: -14.2400732, lng: -53.1805017 }
    let zoom = 5
    if (this.latitude) {
      center = {
        lat: parseFloat(this.latitude),
        lng: parseFloat(this.longitude)
      }
      zoom = 15
    }
    await loader
      .load()
      .then((google) => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: center,
          zoom: zoom
        })
      })
      .catch((error) => {
        console.log(error)
      })
      .then(function () {
        self.map.addListener('dblclick', (e) => {
          if (self.marker) {
            self.marker.setMap(null)
          }
          self.placeMarker(e.latLng.lat(), e.latLng.lng())
        })
        if (self.latitude) {
          self.placeMarker(
            parseFloat(self.latitude),
            parseFloat(self.longitude)
          )
        } else {
          self.placeMarker(
            -14.2400732,
            -53.1805017
          )
        }
        self.initAutoComplete()
      })
  }

  initAutoComplete () {
    const options = {
      fields: ['formatted_address', 'geometry', 'name'],
      strictBounds: false,
      types: ['establishment', 'address']
    }
    const input = document.getElementById('pac-input')
    // TODO
    // eslint-disable-next-line no-undef
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

    const self = this
    // TODO
    // eslint-disable-next-line no-undef
    const searchBox = new google.maps.places.SearchBox(input, options)
    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces()
      if (places.length == 0) {
        return
      }
      const latLng = places[0].geometry.location
      self.map.setCenter(latLng)
      self.map.setZoom(12)
      self.placeMarker(latLng.lat(), latLng.lng())
    })
  }

  placeMarker (lat, lng) {
    this.latitude = lat
    this.longitude = lng
    // TODO
    // eslint-disable-next-line no-undef
    const latLng = new google.maps.LatLng(lat, lng)
    if (this.marker) {
      this.marker.setPosition(latLng)
      return
    }
    // TODO
    // eslint-disable-next-line no-undef
    this.marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: 'teste',
      draggable: true
    })

    const self = this
    // TODO
    // eslint-disable-next-line no-undef
    google.maps.event.addListener(this.marker, 'dragend', function (event) {
      const p = self.marker.getPosition()
      self.latitude = p.lat()
      self.longitude = p.lng()
    })
  }

  async mounted () {
    this.$refs.mapModalDialog.show()
    await this.initMap()
  }

  save () {
    this.$emit('on-coordinate-change', { latitude: this.latitude, longitude: this.longitude })
    this.hideMap()
  }
}
export default MapModal
</script>

<style lang="stylus" scoped>
.consumerUnitAddressContainer {
  border-radius: 0px !important;
}

div.pac-container {
  z-index:9999999999 !important
}

#pac-input {
  width: 400px;
  margin-top: 20px;
}

.map {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
